import {ReactNode} from 'react'
import SectionLoading from '../../loading/section-loading'

const ChartStateBox = ({
  title,
  description,
  chart,
  isLoading,
  footer,
  cardBodyClass = '',
}: {
  title: string
  description: string
  chart: ReactNode
  isLoading?: boolean
  footer?: ReactNode
  cardBodyClass?: string
}) => {
  return (
    <div className='col-xl-4 mt-0'>
      <div className='card border card-flush h-xl-100'>
        <div className={`card-body p-7 ${cardBodyClass}`}>
          <div className='mb-10'>
            <h3 className='mb-0'>{title}</h3>
            <span className='fs-6 fw-semibold text-gray-500'>{description}</span>
            {isLoading && <SectionLoading />}
          </div>
          {chart}
          {footer && footer}
        </div>
      </div>
    </div>
  )
}

export default ChartStateBox
